import {
    OfferRequestTimingGroup as timingGroup,
    timingGroupForConstraint,
} from '@houzy/schemas/offer-request-management';

export { timingGroupForConstraint };

export type OfferRequestTimingGroup = (typeof timingGroup)[keyof typeof timingGroup];
export const OfferRequestTimingGroup = {
    EmergencyNow: timingGroup.emergency_now,
    AsSoonAsPossible: timingGroup.as_soon_as_possible,
    Within4Weeks: timingGroup.within_4_weeks,
    Within3To6Months: timingGroup.within_3_to_6_months,
    Within12Months: timingGroup.within_12_months,
    NotYetDefined: timingGroup.not_yet_defined,
} as const;
